import { IOfficialDailyResponse } from "../../../model/base/response/official-daily-response";
import { Pagination } from "../../../model/paginatiion";

export type OfficialDailyState = {
  officialDaily: Pagination<IOfficialDailyResponse>;
  loading: boolean;
};

export enum ACTION_TYPES {
  loadingData = 'loadingData',
  setLoading = 'setLoading',
  clearData = 'clearData'
}

export const OfficialDailyReducer = (state: OfficialDailyState, action: any): OfficialDailyState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.loadingData:
      return {
        ...state,
        officialDaily: payload,
        loading: false,
      };
    case ACTION_TYPES.setLoading:
      return {
        ...state,
        loading: payload,
      };
    case ACTION_TYPES.clearData:
      return {
        ...state,
        officialDaily: new Pagination<IOfficialDailyResponse>(),
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
